import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import HomePage from '@/components/pages/home/containers/HomePage'

export const Route = createFileRoute('/')({
  validateSearch: z.object({
    error: z.string().optional()
  }),
  component: HomePage
})
